<script setup lang="ts">
// Blank shell — auth/error pages, no chrome (doc 04 §3 layouts).
</script>

<template>
  <v-main>
    <slot />
  </v-main>
</template>
